//to create page links on header and footer

//local
// export const rootUrl = "http://localhost:8888";
// export const rootUrl = "http://localhost:10003";
//export const rootUrl = "http://mynewwordpress.local"; 
// dev
 export const rootUrl = "https://wpreact.goopter.com";
//export const rootUrl = "https://v3-react.goopter.com";
//qa
// export const rootUrl = "https://www.goopter.com";
